const ordersRoutesMeta = {
  routeName: "Orders",
  noPadding: true,
  skipGlobalLoader: true,
  requiredRoles: [],
};

export const ordersRoutes = [
  {
    path: "/app/orders",
    component: () => import("vue-app/pages/PageOrders/PageOrders.vue"),
    meta: ordersRoutesMeta,
  },
];
